import React from 'react';
import styled from 'styled-components';
import { FormWithPrivacyHandler } from 'components/molecules/custom-form';
import { FloatingComponent } from './floating-component';

interface FloatingFormProps {
  projectId: number;
  x: number;
  y: number;
  onSubmit: (content: string) => void;
  onClose: () => void;
  onPrivateBtnClick?: () => void;
  isPrivate?: boolean;
  onChange?: (value: string) => void;
  initialData?: string;
  isLeftAttachment?: boolean;
}

const StyledFloatingFormWrapper = styled.div`
  background-color: white;
  transform: translateX(2rem);
  padding-left: var(--spacing-03);
  padding-right: var(--spacing-03);
  padding-top: var(--spacing-04);
  padding-bottom: var(--spacing-04);
  box-shadow: var(--shadow-12);
  max-width: 400px;
`;

export const FloatingForm: React.FC<FloatingFormProps> = ({
  projectId,
  x,
  y,
  onSubmit,
  onClose,
  onPrivateBtnClick,
  isPrivate = false,
  onChange,
  initialData,
  isLeftAttachment,
}) => {
  return (
    <FloatingComponent y={y} x={x} isLeftAttachment={isLeftAttachment}>
      <StyledFloatingFormWrapper>
        <FormWithPrivacyHandler
          initialFormVisibility
          projectId={projectId}
          isPrivate={isPrivate}
          onClose={onClose}
          onSubmit={onSubmit}
          onPrivateBtnClick={onPrivateBtnClick}
          hidePrivateToggler={false}
          onChange={onChange}
          initialData={initialData}
        />
      </StyledFloatingFormWrapper>
    </FloatingComponent>
  );
};
